import React from "react"
import classnames from "classnames"
import { string } from "prop-types"
import IconArrow from "../../../assets/svg/new-arrow-down.svg"

const Arrow = ({ direction }) => {
  const containerClasses = classnames(
    { DayPickerNavigation_rightButton__horizontal: direction === "right" },
    { DayPickerNavigation_left__horizontal: direction !== "right" }
  )

  return <img src={IconArrow} alt="" className={containerClasses} />
}

Arrow.propTypes = {
  direction: string
}

export default Arrow



// WEBPACK FOOTER //
// ./src/components/DateRangePicker/components/Arrow.js